import { axiosInstance } from "../axiosInstance";
import {
  CheckPendingNotificationsRequest,
  CheckPendingNotificationsResponse,
} from "./types";

export const checkPendingNotifications = async (
  requestData: CheckPendingNotificationsRequest,
): Promise<CheckPendingNotificationsResponse> => {
  const { notificationTypeId } = requestData;

  const response = await axiosInstance.get<CheckPendingNotificationsResponse>(
    `/api/private/notification-types/${notificationTypeId}/pending-count`,
  );
  return response.data;
};
